export default __webpack_public_path__ + "static/media/floppy-hat.ded2c3dc.png";